module.exports = "<svg width=\"18\" height=\"12\" viewBox=\"0 0 18 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.59 1.41L14.17 5H0v2h14.17l-3.59 3.59L12 12l6-6-6-6\" fill=\"none\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/svg/step_arrow.svg
// module id = 828
// module chunks = 0